module.exports = __webpack_public_path__ + "img/calculator-alt.d1e73a41.svg";